import { render } from "./MobileNavigationList.vue?vue&type=template&id=3632a6ba"
import script from "./MobileNavigationList.vue?vue&type=script&lang=js"
export * from "./MobileNavigationList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__